import { createFileRoute } from "@tanstack/react-router";
import CheckInsuranceOptions from "@/pages/CheckInsuranceOptions";
export const Route = createFileRoute("/check-insurance-options")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Check My Insurance Options | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Submit your insurance information for a free, no-obligation benefits verification. Our team checks your coverage for TMS, SAINT TMS, SPRAVATO, and other.",
        },
        {
          property: "og:title",
          content:
            "Check My Insurance Options | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Submit your insurance information for a free, no-obligation benefits verification. Our team checks your coverage for TMS, SAINT TMS, SPRAVATO, and other.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/check-insurance-options",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content:
            "Check My Insurance Options | Neuro Wellness TMS Centers of America",
        },
        {
          name: "twitter:description",
          content:
            "Submit your insurance information for a free, no-obligation benefits verification. Our team checks your coverage for TMS, SAINT TMS, SPRAVATO, and other advanced depression treatment options.",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/check-insurance-options",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CheckInsuranceOptions />;
}
